import request from '@/utils/request'

// v80oFileList
export function v80oFileList(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020Popup/v80oFileList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getFileNo
export function getFileNo(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020Popup/getFileNo`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80o1020UploadFile
export function v80o1020UploadFile(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020Popup/v80o1020UploadFile`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80o1020UpdateReason
export function v80o1020UpdateReason(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020Popup/v80o1020UpdateReason`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80o1020DelFile
export function v80o1020DelFile(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020Popup/v80o1020DelFile`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80oFileListAft
export function v80oFileListAft(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020Popup/v80oFileListAft`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getFileNoAft
export function getFileNoAft(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020Popup/getFileNoAft`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80o1020UploadFileAft
export function v80o1020UploadFileAft(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020Popup/v80o1020UploadFileAft`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80o1020UpdateReasonAft
export function v80o1020UpdateReasonAft(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020Popup/v80o1020UpdateReasonAft`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80o1020DelFileAft
export function v80o1020DelFileAft(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020Popup/v80o1020DelFileAft`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getNetday
export function getNetday(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020Popup/getNetday`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getLastDate
export function getLastDate(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020Popup/getLastDate`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80o1020AddList
export function v80o1020AddList(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020Popup/v80o1020AddList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80o1010Save
export function v80o1010Save(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020Popup/v80o1010Save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80o1020BomDtl
export function v80o1020BomDtl(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020Popup/v80o1020BomDtl`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80oPrintList
export function v80oPrintList(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020Popup/v80oPrintList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// showPageList
export function showPageList(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020Popup/showPageList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80o1020Reinsp
export function v80o1020Reinsp(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020Popup/v80o1020Reinsp`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
